module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "layout"
  }, [(_vm.isHasShop) ? _c('h1', {
    attrs: {
      "id": "shop-logo"
    }
  }, [_c('router-link', {
    staticClass: "mall-home",
    attrs: {
      "to": {
        path: 'shop',
        query: {
          tab: 1,
          store_id: _vm.HeadData.storeId
        }
      },
      "title": "首页"
    }
  }, [_c('img', {
    staticClass: "pngFix",
    attrs: {
      "src": _vm.HeadData.storeLogo
    }
  })]), _vm._v(" "), _c('em', [_vm._v(_vm._s(_vm.HeadData.storeName))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "shop-head-info",
    attrs: {
      "id": "jsddm"
    }
  }, [_c('div', {
    staticClass: "search",
    attrs: {
      "id": "shop-info"
    }
  }, [_c('form', {
    attrs: {
      "method": "get",
      "name": "formSearch",
      "id": "formSearch",
      "action": "home.html"
    }
  }, [_c('input', {
    attrs: {
      "name": "act",
      "id": "search_act",
      "value": "search",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "store_id",
      "value": "2553"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "show_c",
      "value": "4"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "ncs-search-input-text",
    attrs: {
      "name": "keyword",
      "id": "keyword",
      "type": "text",
      "placeholder": "想找什么商品？"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "ncs-search-btn-mall",
    on: {
      "click": function($event) {
        return _vm.search('all')
      }
    }
  }, [_c('span', [_vm._v("全站搜")])]), _vm._v(" "), _c('a', {
    staticClass: "ncs-search-btn-shop",
    on: {
      "click": function($event) {
        return _vm.search('inside')
      }
    }
  }, [_c('span', [_vm._v("店内搜")])])])]), _vm._v(" "), _c('div', {
    staticClass: "favorites"
  }, [_c('i'), _vm._v("收藏"), _c('em'), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "sub"
  }, [_vm._m(0), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "btn",
    attrs: {
      "id": "collect_id"
    },
    on: {
      "click": function($event) {
        return _vm.addCollection()
      }
    }
  }, [_c('i', {
    staticClass: "collected"
  }), _vm._v("收藏")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "store_collect",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "nctype": "store_collect"
    }
  }, [_vm._v(_vm._s(_vm.HeadData.storeCollect))]), _c('span', [_vm._v("收藏人气")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-bar"
  }, [_c('h3', [_vm._v("店铺空间")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4abf8376"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/layout/shop_header.vue
// module id = 1599
// module chunks = 1